<div class="content content--page">
  <div class="content__inner">
    <div class="content__main content__main--page">
      <div class="card card--small">
        <h1 class="card__title">Log In</h1>
        <div class="card__content">
          @if (maintenanceModel()?.maintenanceMode == true) {
          <p class="login__text">{{ maintenanceModel()?.maintenanceMessage }}</p>
          }
          @else if (maintenanceModel()?.maintenanceMode == false) {
          <form [formGroup]="form" (ngSubmit)="onLogin()">
            <div>
              <label for="username">Email Address</label>
              <input #usernameInput id="username" type="text" formControlName="username" placeholder="Email Address" required>
            </div>
            <div>
              <label for="password">Password</label>
              <input type="password" id="password" formControlName="password" placeholder="Password" required>
            </div>
            @if (loginError) {
            <p class="login__text login__text--error">{{ loginError }}</p>
            } @else {
            <p class="login__text">&nbsp;</p>
            }
            <div class="login__submit">
              <button class="login__button button" type="submit">Log In</button>
              <a class="login__forgot-link" routerLink="/account/trouble">Having trouble?</a>
            </div>
          </form>
          }
          @if (loading) {
          <div class="loading-update">
            <div class="loading-update__loader loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
